import { ref, onMounted, onUnmounted } from 'vue'

export default function useBreakpoint() {
  const isMobile = ref(false)

  const check = () => {
    isMobile.value = window.innerWidth <= 991
  }

  onMounted(() => {
    check()
    window.addEventListener('resize', check)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', check)
  })

  return {
    isMobile
  }
}
